import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
import { NacinPlacanja } from './nacin-placanja';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-nacin-placanja-update',
    templateUrl: './nacin-placanja-update.component.html'
})

export class NacinPlacanjaUpdateComponent
extends BaseUpdateComponent<NacinPlacanja>
implements OnInit{

    constructor(
        protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
    ){
        super(activatedRoute, baseDataService, toastrService, translateService);
    }

    ngOnInit(){
        super.ngOnInit();
    }
}